module.exports = {
          srcSet: __webpack_public_path__ + "518597bbf3b6daa736a76ad073657b83-66.jpg"+" 66w",
          images:[ {path: __webpack_public_path__ + "518597bbf3b6daa736a76ad073657b83-66.jpg",width: 66,height: 66}],
          src: __webpack_public_path__ + "518597bbf3b6daa736a76ad073657b83-66.jpg",
          toString:function(){return __webpack_public_path__ + "518597bbf3b6daa736a76ad073657b83-66.jpg"},
          
          width: 66,
          height: 66
        }